import { render, staticRenderFns } from "./PrizeDrawWinnerDocumentModal.vue?vue&type=template&id=6fb56fe6&scoped=true"
import script from "./PrizeDrawWinnerDocumentModal.vue?vue&type=script&lang=js"
export * from "./PrizeDrawWinnerDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb56fe6",
  null
  
)

export default component.exports